import { AdditionalDocumentTags, DocumentTags } from './enums'

export const additionalDocumentTypeOptions: Record<AdditionalDocumentTags, { label: string; key?: string }> = {
  [DocumentTags.STATEMENT_OF_PURPOSE]: { label: 'Statement of Purpose', key: 'statementOfPurpose' },
  [DocumentTags.LETTER_OF_RECOMMENDATION]: { label: 'Letter of Recommendation', key: 'letterOfRecommendation',  },
  [DocumentTags.CONSENT_FORM]: { label: 'Consent Form', key: 'consentForm' },
  [DocumentTags.GMAT_SCORE]: { label: 'GMAT Score', key: 'gmatScore' },
  [DocumentTags.GRE_SCORE]: { label: 'GRE Score', key: 'greScore' },
  [DocumentTags.RESUME]: { label: 'Resume', key: 'resume' },
  [DocumentTags.EMPLOYMENT_LETTER]: { label: 'Employment Letter', key: 'employmentLetter' },
  [DocumentTags.VOLUNTEER_LETTER]: { label: 'Volunteer Letter', key: 'volunteerLetter' },
  [DocumentTags.BIRTH_CERTIFICATE]: { label: 'Birth Certificate', key: 'birthCertificate' },
  [DocumentTags.WES_EVALUATION_REPORT]: { label: 'WES Evaluation Report', key: 'wesEvaluationReport'},
  [DocumentTags.PORTFOLIO]: { label: 'Portfolio', key: 'portfolio' },
  [DocumentTags.FINANCIAL_PROOF]: { label: 'Financial Proof', key: 'financialProof' },
  [DocumentTags.ADDITIONAL_DOCUMENT]: { label: 'Other' },
  [DocumentTags.TUITION_DEPOSIT_RECEIPT]: { label: 'Tuition Deposit Receipt' },
  [DocumentTags.IQAS_ASSESSMENT]: { label: 'IQAS Assessment' },
  [DocumentTags.CASPER_TEST_SCORE_REPORT]: { label: 'Casper Test Score Report' },
  [DocumentTags.SNAPSHOT]: { label: 'Snapshot' },
  [DocumentTags.PROOF_OF_NAME_CHANGE]: { label: 'Proof of Name Change' },
  [DocumentTags.RELEASE_OF_INFORMATION_FORM]: { label: 'Release of Information Form' },
  [DocumentTags.AUTHORIZED_RP_RELEASE_OF_INFORMATION_FORM]: { label: 'Authorized RP Release of Information Form' },
}

export const documentTypeOptions: Record<DocumentTags, { label: string }> = {
  ...additionalDocumentTypeOptions,
  [DocumentTags.CERTIFICATE]: { label: 'Certificate' },
  [DocumentTags.DECLINED_LETTER]: { label: 'Declined Letter' },
  [DocumentTags.DESTINATION_COUNTRY_STATUS]: { label: 'Destination Country Status' },
  [DocumentTags.LANGUAGE_TEST]: { label: 'Language Proficiency' },
  [DocumentTags.LANGUAGE_TEST_IELTS]: { label: 'Language Proficiency' },
  [DocumentTags.LANGUAGE_TEST_PTE]: { label: 'Language Proficiency' },
  [DocumentTags.LANGUAGE_TEST_TOEFL]: { label: 'Language Proficiency' },
  [DocumentTags.LANGUAGE_TEST_DUOLINGO]: { label: 'Language Proficiency' },
  [DocumentTags.LANGUAGE_TEST_OTHER]: { label: 'Language Proficiency' },
  [DocumentTags.LANGUAGE_TEST_CAEL]: { label: 'Language Test' },
  [DocumentTags.LANGUAGE_TEST_MET]: { label: 'Language Test' },
  [DocumentTags.LANGUAGE_TEST_CAMBRIDGE]: { label: 'Language Test' },
  [DocumentTags.LANGUAGE_TEST_EPP]: { label: 'Language Test' },
  [DocumentTags.LANGUAGE_TEST_CANTEST]: { label: 'Language Test' },
  [DocumentTags.LANGUAGE_TEST_LANGUAGECERT_ESOL]: { label: 'Language Test' },
  [DocumentTags.LANGUAGE_TEST_LEAP_4_ADVANCED]: { label: 'Language Test' },
  [DocumentTags.PASSPORT]: { label: 'Passport' },
  [DocumentTags.PRE_OFFER_LETTER]: { label: 'Pre Offer Letter' },
  [DocumentTags.FINAL_OFFER_LETTER]: { label: 'Final Offer Letter' },
  [DocumentTags.WAITLIST_LETTER]: { label: 'Waitlist Letter' },
  [DocumentTags.STUDY_PERMIT]: { label: 'Study Permit' },
  [DocumentTags.REFUGEE]: { label: 'Refugee' },
  [DocumentTags.REFUGEE_CLAIMANT]: { label: 'Refugee Claimant' },
  [DocumentTags.TRANSCRIPTS]: { label: 'Transcript' },
  [DocumentTags.VISITOR_TOURIST_VISA]: { label: 'Visitor Tourist Visa' },
  [DocumentTags.WORK_PERMIT]: { label: 'Work Permit' },
  [DocumentTags.VISA_OUTCOME]: { label: 'Visa Outcome' },
  [DocumentTags.TUITION_DEPOSIT_RECEIPT]: { label: 'Tuition Deposit Receipt' },
  [DocumentTags.SCHOOL_ADDITIONAL_DOCUMENT]: { label: 'School Additional Document' },
}

export function getDocumentTypeLabel(documentType: DocumentTags): string {
  if (documentTypeOptions[documentType]) {
    return documentTypeOptions[documentType].label
  }
  return documentType
    .toLowerCase()
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}